module.exports = __webpack_public_path__ + "static/skateboard-7f9777e2c8fb64d40f79f019aa0135ac.jpg";